import { T_MongoDoc } from "../types/_utils.types";
import { T_Category } from "./category.dto";

export type BlogDto = {
  title: string;
  published_at?: string;
  pagetitle?: string;
  description: string;
  html: string;
  author: string;
  comments: string[];
  slug: string;
  feature_image: string;
  status: BlogStatusTypes;
  visiblity: BlogVisibilityTypes;
  featured: boolean;
  tags: string[];
  categories: T_Category[];
  is_saved: boolean;
  is_liked: boolean;
  number_of_likes: string;
  og: TOgMeta;
  twitter: TTwitterMeta;
  blog_sites?: BlogSitesDto[];
  // createdAt: string;
  // updatedAt: string;
  // _id: string;
};

export type BlogSitesDto = {
  _id: string;
  name: string;
  slug: string;
  site_code: string; // 6 character random sequence (all smallcase + numbers)
  is_deletable?: boolean;
  seo?: {
    site_name: string;
    site_title: string;
    site_description: string;
    twitter_site_name: string;
    twitter_author: string;
    twitter_description: string;
    twitter_title: string;
  };
  credentials?: {
    key: string; // 16 char alphanumeric
    secret: string; // 32 char alphanumeric
  };
  referrers?: string[]; // domain names
};

export type BlogSchemaDto = BlogDto & T_MongoDoc;

// export type Tags = {
//   title: string;
//   usage_counter: number;
//   slug: string;
// };

export enum BlogStatusTypes {
  DRAFT = "DRAFT",
  PUBLISHED = "PUBLISHED",
  ARCHIVED = "ARCHIVED",
}

export enum TwitterCardTypes {
  SUMMARY_LARGE_IMAGE = "summary_large_image",
  SUMMARY = "summary",
}

export enum BlogVisibilityTypes {
  OPEN_TO_ALL = "OPEN_TO_ALL",
  MEMBERSHIP_ONLY = "MEMBERSHIP_ONLY",
  UNPUBLISHED = "UNPUBLISHED",
  HIDDEN = "HIDDEN",
}

export enum BlogFeaturedTypes {
  YES = "YES",
  NO = "NO",
}

export enum ContentType {
  BLOG = "BLOG",
  CUSTOMER_STORY = "CUSTOMER STORY",
}
export type CreateBlogDto = Omit<BlogDto, "author" | "number_of_likes" | "status" | "visibility"> & {
  status?: BlogStatusTypes;
  visiblity?: BlogVisibilityTypes;
  tags?: string[];
};

export type TOgMeta = {
  ogTitle: string;
  ogDescription: string;
  ogImage: string;
  ogSiteName: string;
  ogUrl: string;
  seoPageTitle: string;
  seoDescription: string;
};

export type TTwitterMeta = {
  twitterAuthor: string;
  twitterCardType: TwitterCardTypes;
  twitterTitle: string;
  twitterDescription: string;
  twitterSite: string;
};

export type UpdateBlog = BlogDto;
export type DeleteBlog = BlogDto;
